import { Box } from '@mui/material';
import { memo, useCallback, useState } from 'react';

import Searchbar from './search-bar.component';
import SearchResults from './search-results.component';
import { useNavigate } from 'react-router-dom';
import { useSearchUnderlyings } from '@oai-frontend-monorepo/api';

type Params = {
  onResultSelected?: (symbol: string) => void;
};

const Search = ({ onResultSelected }: Params) => {
  const [value, setValue] = useState('');

  const { data } = useSearchUnderlyings({ searchValue: value });

  const nav = useNavigate();

  const handleSelect = useCallback(
    (symbol: string) => {
      setValue('');

      if (onResultSelected) {
        onResultSelected(symbol);
        return;
      }

      nav(`/trade/${symbol}`);
    },
    [nav, onResultSelected]
  );

  const handleEnter = useCallback(() => {
    if (data.length > 0) {
      handleSelect(data[0].symbol);
    }
  }, [data, handleSelect]);

  return (
    <Box>
      <Searchbar onEnter={handleEnter} value={value} onChange={setValue} />

      <Box position="relative" zIndex={2}>
        <SearchResults results={data} onSelect={handleSelect} />
      </Box>
    </Box>
  );
};

export default memo(Search);
